import { render, staticRenderFns } from "./newNyfk.vue?vue&type=template&id=6ca48b34&scoped=true"
import script from "./newNyfk.vue?vue&type=script&lang=js"
export * from "./newNyfk.vue?vue&type=script&lang=js"
import style0 from "./newNyfk.vue?vue&type=style&index=0&id=6ca48b34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca48b34",
  null
  
)

export default component.exports